/**
 * @description The enumeration of the States
 * @since 1.0.0
 * @enum {String}
 * @readonly
 * @public
 */
const STATES = {
  MULTISTATE: {
    key: "MU",
    title: "Multistate",
    description: "Multistate",
  },
  ALABAMA: {
    key: "AL",
    title: "Alabama",
    description: "Alabama",
  },
  ALASKA: {
    key: "AK",
    title: "Alaska",
    description: "Alaska",
  },
  ARIZON: {
    key: "AZ",
    title: "Arizona",
    description: "Arizona",
  },
  ARKANSAS: {
    key: "AR",
    title: "Arkansas",
    description: "Arkansas",
  },
  CALIFORNIA: {
    key: "CA",
    title: "California",
    description: "California",
  },
  COLORADO: {
    key: "CO",
    title: "Colorado",
    description: "Colorado",
  },
  CONNECTICUT: {
    key: "CT",
    title: "Connecticut",
    description: "Connecticut",
  },
  DELAWARE: {
    key: "DE",
    title: "Delaware",
    description: "Delaware",
  },
  DISTRICT_OF_COLUMBIA: {
    key: "DC",
    title: "District of Columbia",
    description: "District of Columbia",
  },
  FLORIDA: {
    key: "FL",
    title: "Florida",
    description: "Florida",
  },
  GEORGIA: {
    key: "GA",
    title: "Georgia",
    description: "Georgia",
  },
  HAWAII: {
    key: "HI",
    title: "Hawaii",
    description: "Hawaii",
  },
  IDAHO: {
    key: "ID",
    title: "Idaho",
    description: "Idaho",
  },
  ILLINOIS: {
    key: "IL",
    title: "Illinois",
    description: "Illinois",
  },
  INDIANA: {
    key: "IN",
    title: "Indiana",
    description: "Indiana",
  },
  IOWA: {
    key: "IA",
    title: "Iowa",
    description: "Iowa",
  },
  KANSAS: {
    key: "KS",
    title: "Kansas",
    description: "Kansas",
  },
  KENTUCKY: {
    key: "KY",
    title: "Kentucky",
    description: "Kentucky",
  },
  LOUISIANA: {
    key: "LA",
    title: "Louisiana",
    description: "Louisiana",
  },
  MAINE: {
    key: "ME",
    title: "Maine",
    description: "Maine",
  },
  MARYLAND: {
    key: "MD",
    title: "Maryland",
    description: "Maryland",
  },
  MASSACHUSETTS: {
    key: "MA",
    title: "Massachusetts",
    description: "Massachusetts",
  },
  MICHIGAN: {
    key: "MI",
    title: "Michigan",
    description: "Michigan",
  },
  MINNESOTA: {
    key: "MN",
    title: "Minnesota",
    description: "Minnesota",
  },
  MISSISSIPPI: {
    key: "MS",
    title: "Mississippi",
    description: "Mississippi",
  },
  MISSOURI: {
    key: "MO",
    title: "Missouri",
    description: "Missouri",
  },
  MONTANA: {
    key: "MT",
    title: "Montana",
    description: "Montana",
  },
  NEBRASKA: {
    key: "NE",
    title: "Nebraska",
    description: "Nebraska",
  },
  NEVADA: {
    key: "NV",
    title: "Nevada",
    description: "Nevada",
  },
  NEW_HAMSHIRE: {
    key: "NH",
    title: "New Hampshire",
    description: "New Hampshire",
  },
  NEW_JERSEY: {
    key: "NJ",
    title: "New Jersey",
    description: "New Jersey",
  },
  NEW_MEXICO: {
    key: "NM",
    title: "New Mexico",
    description: "New Mexico",
  },
  NEW_YORK: {
    key: "NY",
    title: "New York",
    description: "New York",
  },
  NORTH_CAROLINA: {
    key: "NC",
    title: "North Carolina",
    description: "North Carolina",
  },
  NORTH_DAKOTA: {
    key: "ND",
    title: "North Dakota",
    description: "North Dakota",
  },
  OHIO: {
    key: "OH",
    title: "Ohio",
    description: "Ohio",
  },
  OKLAHOMA: {
    key: "OK",
    title: "Oklahoma",
    description: "Oklahoma",
  },
  OREGON: {
    key: "OR",
    title: "Oregon",
    description: "Oregon",
  },
  PENNSYLVANIA: {
    key: "PA",
    title: "Pennsylvania",
    description: "Pennsylvania",
  },
  PUERTO_RICO: {
    key: "PR",
    title: "Puerto Rico",
    description: "Puerto Rico",
  },
  RHODE_ISLAND: {
    key: "RI",
    title: "Rhode Island",
    description: "Rhode Island",
  },
  SOUTH_CAROLINA: {
    key: "SC",
    title: "South Carolina",
    description: "South Carolina",
  },
  SOUTH_DAKOTA: {
    key: "SD",
    title: "South Dakota",
    description: "South Dakota",
  },
  TENNESSEE: {
    key: "TN",
    title: "Tennessee",
    description: "Tennessee",
  },
  TEXAS: {
    key: "TX",
    title: "Texas",
    description: "Texas",
  },
  UTAH: {
    key: "UT",
    title: "Utah",
    description: "Utah",
  },
  VERMONT: {
    key: "VT",
    title: "Vermont",
    description: "Vermont",
  },
  VIRGINIA: {
    key: "VA",
    title: "Virginia",
    description: "Virginia",
  },
  WASHINGTON: {
    key: "WA",
    title: "Washington",
    description: "Washington",
  },
  WEST_VIRGINA: {
    key: "WV",
    title: "West Virginia",
    description: "West Virginia",
  },
  WISCONSIN: {
    key: "WI",
    title: "Wisconsin",
    description: "Wisconsin",
  },
  WYOMING: {
    key: "WY",
    title: "Wyoming",
    description: "Wyoming",
  },
};

export default STATES;
